import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import { LightDomSlotFallbackController } from '../../lib/light-dom-slot-fallback/light-dom-slot-fallback-controller.js';
import { CrntBoxedInputMixin, processingLightDomSlotFallbackControllerSlot } from '../boxed-input/boxed-input-mixin.js';
import { CrntIcon } from '../icon/icon.component.js';
import selectStyles from './select.css.js';

class CrntSelect extends CrntBoxedInputMixin(CrntElement) {
  constructor() {
    super(...arguments);
    this._lightDomSlotFallbackController = new LightDomSlotFallbackController(this, [
      processingLightDomSlotFallbackControllerSlot,
      () => ({
        fallbackElement: () => {
          const icon = new CrntIcon();
          icon.icon = "chevron-down";
          return icon;
        },
        override: true,
        slotName: "trailing"
      })
    ]);
  }
  static {
    this.dependencies = {
      "crnt-icon": CrntIcon
    };
  }
  static {
    this.styles = [CrntBoxedInputMixin(CrntElement).styles || [], trustedCSS(selectStyles)];
  }
  static {
    this.tagName = "crnt-select";
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    this._lightDomSlotFallbackController.setFallbackSlotsContent();
  }
}

export { CrntSelect };
